module.exports = __webpack_public_path__ + "img/healthbook_logo.084f78ba.svg";